import React, { useState, useRef, useEffect } from "react";
import styles from "./CBSEClass12Syllabus.module.css";
import Chatbot from "../../components/chatbot";
import SocialSidebar from "../../components/SocialSideBar";

// --- Complete CBSE Class 12 Syllabus Data ---
const syllabusData = {
  physics: [
    { unit: "Electrostatics", chapterNo: 1, chapter: "Chapter1. Electric Charges and Fields", marks: 8, notes: "Focus on basic concepts and numerical problems." },
    { unit: "", chapterNo: 2, chapter: "Chapter2. Electrostatic Potential and Capacitance", marks: 8, notes: "Conceptual clarity and derivations." },
    { unit: "Current Electricity", chapterNo: 3, chapter: "Chapter3. Current Electricity", marks: 10, notes: "Core laws emphasized." },
    { unit: "Magnetic Effects of Current and Magnetism", chapterNo: 4, chapter: "Chapter4. Moving Charges and Magnetism", marks: 9, notes: "Biot-Savart law, Ampere's law." },
    { unit: "", chapterNo: 5, chapter: "Chapter5. Magnetism and Matter", marks: 8, notes: "Cyclotron optional." },
    { unit: "Electromagnetic Induction and Alternating Currents", chapterNo: 6, chapter: "Chapter6. Electromagnetic Induction", marks: 6, notes: "Faraday & Lenz laws." },
    { unit: "", chapterNo: 7, chapter: "Chapter7. Alternating Current", marks: 6, notes: "AC circuits: RMS, reactance." },
    { unit: "Electromagnetic Waves", chapterNo: 8, chapter: "Chapter8. Electromagnetic Waves", marks: 18, notes: "Wave equation, EM spectrum." },
    { unit: "Optics", chapterNo: 9, chapter: "Chapter9. Ray Optics and Optical Instruments", marks: 7, notes: "Lens/mirror formulae and instruments." },
    { unit: "", chapterNo: 10, chapter: "Chapter10. Wave Optics", marks: 7, notes: "Interference, diffraction, polarization." },
    { unit: "Dual Nature of Radiation and Matter", chapterNo: 11, chapter: "Chapter11. Dual Nature of Radiation and Matter", marks: 12, notes: "Photoelectric effect, de Broglie wavelength." },
    { unit: "Atoms and Nuclei", chapterNo: 12, chapter: "Chapter12. Atoms", marks: 3.5, notes: "Bohr model and spectra." },
    { unit: "", chapterNo: 13, chapter: "Chapter13. Nuclei", marks: 3.5, notes: "Binding energy and nuclear properties." },
    { unit: "Electronic Devices", chapterNo: 14, chapter: "Chapter14. Semiconductor Electronics: Materials, Devices, and Simple Circuits", marks: 8, notes: "Diodes, transistors; basic circuits." }
  ],
  chemistry: [
    { chapterNo: 1, chapter: "Chapter1. Solutions", marks: 7, notes: "Focus on problems and concepts." },
    { chapterNo: 2, chapter: "Chapter2. Electrochemistry", marks: 9, notes: "Ionic conductance optional." },
    { chapterNo: 3, chapter: "Chapter3. Chemical Kinetics", marks: 7, notes: "Standard content retained." },
    { chapterNo: 4, chapter: "Chapter4. d and f-Block Elements", marks: 7, notes: "Oxidation states and properties." },
    { chapterNo: 5, chapter: "Chapter5. Coordination Compounds", marks: 7, notes: "Core concepts of ligands and bonding." },
    { chapterNo: 6, chapter: "Chapter6. Haloalkanes and Haloarenes", marks: 6, notes: "Nomenclature and reactions." },
    { chapterNo: 7, chapter: "Chapter7. Alcohols, Phenols, and Ethers", marks: 6, notes: "Preparation and reactions." },
    { chapterNo: 8, chapter: "Chapter8. Aldehydes, Ketones, and Carboxylic Acids", marks: 8, notes: "Standard content." },
    { chapterNo: 9, chapter: "Chapter9. Amines", marks: 6, notes: "Basic reactions emphasized." },
    { chapterNo: 10, chapter: "Chapter10. Biomolecules", marks: 7, notes: "Definitions and classifications." }
  ],
  biology: [
    { unit: "Reproduction", chapter: "Chapter1. Sexual Reproduction in Flowering Plants", marks: 6, notes: "Complete reproduction cycle." },
    { unit: "", chapter: "Chapter2. Human Reproduction", marks: 5, notes: "Male & female reproductive systems." },
    { unit: "", chapter: "Chapter3. Reproductive Health", marks: 5, notes: "Family planning & STDs." },
    { unit: "Genetics and Evolution", chapter: "Chapter4. Principles of Inheritance and Variation", marks: 7, notes: "Mendelian genetics." },
    { unit: "", chapter: "Chapter5. Molecular Basis of Inheritance", marks: 7, notes: "DNA/RNA structure and replication." },
    { unit: "", chapter: "Chapter6. Evolution", marks: 6, notes: "Speciation & natural selection." },
    { unit: "Biology and Human Welfare", chapter: "Chapter7. Human Health and Diseases", marks: 6, notes: "Pathogens and immunology." },
    { unit: "", chapter: "Chapter8. Microbes in Human Welfare", marks: 6, notes: "Applications in medicine & industry." },
    { unit: "Biotechnology and its Applications", chapter: "Chapter9. Biotechnology - Principles and Processes", marks: 12, notes: "Recombinant DNA technology." },
    { unit: "Ecology and Environment", chapter: "Chapter10. Organisms and Populations", marks: 4, notes: "Population ecology." },
    { unit: "", chapter: "Chapter11. Ecosystem", marks: 3, notes: "Energy flow and diagrams." },
    { unit: "", chapter: "Chapter12. Biodiversity and its Conservation", marks: 3, notes: "Hotspots & conservation strategies." }
  ],
  mathematics: [
    { unitName: "Relations and Functions", chapter: "Chapter1. Relations and Functions", marks: 4, notes: "Basic definitions and types." },
    { unitName: "", chapter: "Chapter2. Inverse Trigonometric Functions", marks: 4, notes: "Principal values and graphs." },
    { unitName: "Algebra", chapter: "Chapter3. Matrices", marks: 5, notes: "Operations and applications." },
    { unitName: "", chapter: "Chapter4. Determinants", marks: 5, notes: "Cramer's rule included." },
    { unitName: "Calculus", chapter: "Chapter5. Continuity and Differentiability", marks: 7, notes: "Limits, derivatives." },
    { unitName: "", chapter: "Chapter6. Applications of Derivatives", marks: 7, notes: "Maxima/minima, tangents, normals." },
    { unitName: "", chapter: "Chapter7. Integrals", marks: 7, notes: "Standard integrals and applications." },
    { unitName: "", chapter: "Chapter8. Applications of Integrals", marks: 7, notes: "Area under curves and between curves." },
    { unitName: "", chapter: "Chapter9. Differential Equations", marks: 7, notes: "Separable equations." },
    { unitName: "Vectors and 3D Geometry", chapter: "Chapter10. Vectors", marks: 7, notes: "Addition, scalar & vector products." },
    { unitName: "", chapter: "Chapter11. Three-Dimensional Geometry", marks: 7, notes: "Lines, planes, direction ratios." },
    { unitName: "Linear Programming", chapter: "Chapter12. Linear Programming", marks: 5, notes: "Graphical solution; basic problems." },
    { unitName: "Probability", chapter: "Chapter13. Probability", marks: 8, notes: "Conditional probability, Bayes theorem." }
  ],
  hindi: [
    { section: " अवगति बोध (Unseen Passages)", marks: 18, notes: "Comprehension practice." },
    { section: " अभिव्यक्ति एवं माध्यम (Expression & Medium)", marks: 22, notes: "Essay, article, formal/informal letters." },
    { section: " आरोह & वितान (Prose & Poetry from textbooks)", marks: 40, notes: "Key prose & poetry chapters retained." }
  ],
  english: [
    { section: " Reading", chapter: "Two unseen passages (factual/literary & case-based)", marks: 22, notes: "Comprehension & inference." },
    { section: " Writing", chapter: "Notice, formal/informal invitations, letters, article, report", marks: 18, notes: "Core writing tasks emphasized." },
    { section: " Literature", chapter: "Flamingo & Vistas: MCQs, objective, short & long answer type questions", marks: 40, notes: "Retained chapters focus." }
  ]
};

// --- Table Component ---
const SyllabusTable = ({ data }) => (
  <div className={styles['table-container']}>
    <table className={styles['syllabus-table']}>
      <thead>
        <tr>
          <th>Unit / Section</th>
          <th>Chapter Name</th>
          <th>Approx. Marks*</th>
          <th>Notes / Status</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr key={index}>
            <td>{item.unit || item.unitName || item.section || "-"}</td>
            <td>{item.chapter || item.unitName || item.section}</td>
            <td className={styles['marks-column']}>{item.marks}</td>
            <td>{item.notes}</td>
          </tr>
        ))}
      </tbody>
    </table>
    <p className={styles['table-footer']}>
      *Marks are approximate unit-wise weightage for theory paper (80 marks)
    </p>
  </div>
);

// --- Main Component ---
const CBSEClass12Syllabus = () => {
  const [activeTab, setActiveTab] = useState("mathematics");
  const [indicatorStyle, setIndicatorStyle] = useState({});
  const tabsRef = useRef(null);

  const tabs = [
    { id: "mathematics", label: "Mathematics 📐" },
    { id: "physics", label: "Physics ⚛️" },
    { id: "chemistry", label: "Chemistry 🌍" },
    { id: "biology", label: "Biology 🧬" },
    { id: "english", label: "English 📚" },
    { id: "hindi", label: "Hindi 🇮🇳" },
  ];

  useEffect(() => {
    const activeTabIndex = tabs.findIndex((tab) => tab.id === activeTab);
    const activeTabElement = tabsRef.current?.children[activeTabIndex];

    if (activeTabElement) {
      setIndicatorStyle({
        left: activeTabElement.offsetLeft,
        width: activeTabElement.offsetWidth,
      });
    }
  }, [activeTab]);

  return (
    <div className={styles['syllabus-container']}>
      <Chatbot />
      <SocialSidebar />

      <header className={styles['syllabus-header']}>
        <h1>
          <span role="img" aria-label="Syllabus icon">🎓</span>
          <span className={styles['gradient-text']}>Class 12 Syllabus</span>
        </h1>
        <p>Subject-wise breakdown and Chapter Status for the current academic session.</p>
      </header>

      <div className={styles['syllabus-tabs-container']}>
        <div className={styles['syllabus-tabs']} ref={tabsRef}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`${styles.tab} ${activeTab === tab.id ? styles.active : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
          <span className={styles['tab-indicator']} style={indicatorStyle} />
        </div>
      </div>

      <SyllabusTable data={syllabusData[activeTab]} />
    </div>
  );
};

export default CBSEClass12Syllabus;
